import { render, staticRenderFns } from "./FamilyInfoWidget.vue?vue&type=template&id=2f4a56aa&scoped=true"
import script from "./FamilyInfoWidget.vue?vue&type=script&lang=js"
export * from "./FamilyInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./FamilyInfoWidget.vue?vue&type=style&index=0&id=2f4a56aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a56aa",
  null
  
)

/* custom blocks */
import block0 from "./FamilyInfoWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports